import React, { useEffect, useState } from "react";
import "../styles/local/InvoiceAllList.css";
import moment from "moment";
import sideBarLogo from "../icons/sideBarLogo.png";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";

const InvoicePDF = ({ invoicePDFData }) => {
  const [invoiceid, setInvoiceid] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("");
  const [iban, setIban] = useState("");
  const [bic, setBic] = useState("");
  const [logo, setLogo] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [poNo, setPoNo] = useState("");
  const [quoteNo, setQuoteNo] = useState("");
  const [refNo, setRefNo] = useState("");
  const [total, setTotal] = useState("");
  const [totalBalance, setTotalBalance] = useState("");
  const [vatTotal, setVatTotal] = useState("");
  const [discountTotal, setDiscountTotal] = useState("");

  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientVatNo, setClientVatNo] = useState("");
  const [invoicestatus, setInvoicestatus] = useState("");

  useEffect(() => {
    if (invoicePDFData !== null) {
      setInvoiceid(invoicePDFData[0]?.invoiceNo);
      setPaymentMethod(invoicePDFData[0]?.paymentMethod);
      setPaymentTerms(invoicePDFData[0]?.paymentTerms);
      setIban(invoicePDFData[0]?.iban);
      setBic(invoicePDFData[0]?.bicNo);
      setLogo(invoicePDFData[0]?.logo);
      setInvoiceDate(invoicePDFData[0]?.invoiceDate);
      setDueDate(invoicePDFData[0]?.dueDate);
      setPoNo(invoicePDFData[0]?.poNo);
      setQuoteNo(invoicePDFData[0]?.quoteNo);
      setRefNo(invoicePDFData[0]?.refNo);
      setTotal(invoicePDFData[0]?.total);
      setTotalBalance(invoicePDFData[0]?.totalBalance);
      setVatTotal(invoicePDFData[0]?.vatTotal);
      setDiscountTotal(invoicePDFData[0]?.discountTotal);
      setInvoicestatus(invoicePDFData[0]?.invoicestatus);

      setClientName(invoicePDFData[0]?.client?.name);
      setClientAddress(invoicePDFData[0]?.client?.address);
      setClientEmail(invoicePDFData[0]?.client?.email);
      setClientVatNo(invoicePDFData[0]?.client?.vatNo);
    } else {
    }
  }, [invoicePDFData]);

  console.log("asc67", invoicePDFData);

  return (
    <div className="pt-1 p-5" id="teamPDFSection">
      <div className="d-flex justify-content-between">
        <img src={sideBarLogo} alt="logo" className="sideLogo" />
        <div className="d-flex gap-5 pt-3 px-3 invoiceHead">
          <p className="mb-0">
            {invoicestatus === "Credit" ? "Credit" : "Invoice"}
          </p>
          <p className="mb-0">
            {`ID ${invoiceid} | ${moment(invoiceDate).format("DD.MM.YYYY")}`}
          </p>
        </div>
      </div>

      <div
        className="ms-auto paymentTerms pb-0"
        style={{
          display: invoicestatus === "Credit" ? "none" : "block",
        }}
      >
        <div className="d-flex">
          <div className="paymentTermsLabl" style={{ width: "40%" }}>
            <p>Payment Terms</p>
            <p>Due Date</p>
            <p className="mb-0">
              Payment Method
              <br />
              IBAN
            </p>
          </div>
          <div className="paymentTermsVal">
            <p>{paymentTerms || "—"}</p>
            <p>{moment(dueDate).format("DD.MM.YYYY") || "—"}</p>
            <p>
              {paymentMethod || "—"}
              <br />
              {iban || "—"}
            </p>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between pt-5 pe-4">
        <div className="ps-3 clinetInform" style={{ width: "45%" }}>
          <p className="mb-1">To</p>
          <p className="fw-bold mb-1">{clientName}</p>
          <p className="mb-2">
            {/* <pre>{clientAddress?.replace(/, /g, "\n")}</pre> */}
            {clientAddress?.split(", ").map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </p>
          <p className="mb-2">{clientEmail}</p>
          <p className="mb-2">{clientVatNo}</p>
        </div>

        <div className="quoteInform">
          <p className="invisible">ASC</p>
          <p className="invisible">ASC</p>
          <p className="mb-2">Quote</p>
          <p className="mb-2">PO</p>
          <p className="mb-2">Ref.</p>
        </div>

        <div className="quoteInformVal">
          <p className="invisible pe-5">ASC</p>
          <p className="invisible pe-5">ASC</p>
          <p className="mb-2">{quoteNo || "_"}</p>
          <p className="mb-2">{poNo || "_"}</p>
          <p className="mb-2">{refNo || "_"}</p>
        </div>
      </div>

      <div className="p-2 mt-4" style={{ backgrounddd: "#FAFAFA" }}>
        <table
          className="table mb-0"
          style={{ fontSize: "13px", background: "#FAFAFA" }}
        >
          <thead>
            <tr
              className="tableHeading_pdf"
              style={{
                borderBottom: "1px dotted grey",
                color: "#9A9999",
                fontSize: "10px",
              }}
            >
              <th className="txtField_pdf" style={{ width: "2-0%" }}>
                Item id
              </th>
              <th className="txtField_pdf" style={{ width: "25%" }}>
                Item Description
              </th>
              <th className="txtField_pdf" style={{ width: "1-5%" }}>
                Qty
              </th>
              <th className="txtField_pdf" style={{ width: "15%" }}>
                Unit Price
              </th>
              <th className="txtField_pdf" style={{ width: "1-5%" }}>
                Discount
              </th>
              <th className="txtField_pdf" style={{ width: "2-0%" }}>
                VAT
              </th>
              <th className="txtField_pdf">Total</th>
            </tr>
          </thead>

          <tbody className="tabLine" style={{ borderTop: "1px dotted" }}>
            {invoicePDFData[0]?.lineItems?.map((item, index) => {
              console.log("asc444", item);
              return (
                <tr className="trHover" style={{ borderBottom: "1px dotted" }}>
                  <td className="itemidtxt py-3">{item.itemId || "—"}</td>
                  <td className="tablePdfVal py-3">
                    {/* {item.itemDescription || "—"} */}
                    {`${item.itemDescription} ${" "} ${item.suffix ?? ""} ` ||
                      "—"}
                  </td>
                  <td className="totalTxtpdf py-3">{item.qty || "—"}</td>
                  <td className="tablePdfVal py-3">
                    {europeanFormatWithSymbol(item.unitPrice) || "—"}
                  </td>
                  <td className="tablePdfVal py-3">{item.discount || "0"}%</td>

                  <td className="tablePdfVal py-3">{`${item.vat || "0"}`}%</td>
                  <td className="totalTxtpdf py-3">
                    {/* {`€ ${item.total.toFixed(2) || "—"}`} */}
                    {/* {europeanFormatWithSymbol(item.total) || "—"} */}
                    {europeanFormatWithSymbol(item.qty * item.unitPrice) || "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div
          className="d-flex pt-2"
          style={{ paddingLeft: "20rem", background: "rgb(250, 250, 250)" }}
        >
          <div className="tablePdfVal" style={{ width: "150px" }}>
            <p className="mb-2">Total</p>
            <p className="mb-2">Discount</p>
            <p className="mb-2">VAT &nbsp;</p>
            <p className="totalBalance mb-2">TOTAL BALANCE</p>
          </div>

          <div className="tablePdfVal text-end" style={{ width: "150px" }}>
            <p className="mb-2">{europeanFormatWithSymbol(total)}</p>
            <p className="mb-2">{europeanFormatWithSymbol(discountTotal)}</p>
            <p className="mb-2">{europeanFormatWithSymbol(vatTotal)}</p>
            <p className="totalBalance mb-2">
              {europeanFormatWithSymbol(totalBalance)}
            </p>
          </div>
        </div>

        <div className="">
          <p
            className="ps-3"
            style={{
              width: "260px",
              textWrap: "auto",
              fontSize: "10px",
              color: "#333333",
            }}
          >
            Thank you for your continued trust and partnership. We appreciate a
            prompt payment.
            <br />
            IBAN: {iban}
            <br />
            BIC: {bic}
          </p>
        </div>
      </div>

      <footer>
        <div className="row gap5 pt-3 px-3 d-none">
          <div
            className="col-1"
            style={{
              transform: "rotate(270deg)",
              fontSize: "10px",
              color: "#333333",
            }}
          >
            VAT No. XX009000000
          </div>
          <div className="paymentTermsVal col-4">
            <p className="mb-0 fw-bold">Company Name B.V.</p>
            <p className="mb-0">Company Address here in this line</p>
            <p className="mb-0">Company Address here in this line</p>
            <p className="mb-0">Zip Code, City</p>
          </div>

          <div className="paymentTermsVal col-3">
            <p className="mb-0 fw-bold">www.website.com</p>
            <p className="mb-0">+35 1234 5678</p>
            <p className="mb-0">email@example.com</p>
            <p className="mb-0">KvK no. 000000000</p>
          </div>

          <div className="paymentTermsVal col-4">
            <p className="mb-0 invisible">ASC</p>
            <p className="mb-0 invisible">ASC</p>
            <p className="mb-0 invisible">ASC</p>
            <p className="mb-0">Powered by www.spire.solutions | Pag 1/1</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default InvoicePDF;
